module.exports = __webpack_public_path__ + "static/img/logoMain.0c38a36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logoMain.png
// module id = FfEr
// module chunks = 3